import appsService from '@/services/appsService'
import i18n from '@/plugins/i18n/index.js'

const state = {
  appCustomExtradatas: [],
  apps: [],
  appModules: [],
  datesRange: [],
  loadingApps: true,
  loadingAppsStatistics: true,
  selectedApp: {},
  statistics: {},
  searchParams: {},
  instagramUsersLikings: [],
  spotifyUsersTopGenres: [],
  spotifyUsersTopArtists: [],
  spotifyUsersTopTracks: [],
  toolbarDateRangeVisual: { numDays: 7 }, // { // also can be { fromDate, toDate }
  //   fromDate: '',
  //   toDate: '',
  //   allData: false
  // }
  toolbarDateRange: { // always an object
    fromDate: '',
    toDate: '',
    allData: false
  },
  isManualChargeShown: false,
  tags: []
}

const mutations = {
  'CLEAR_SELECTED_APP' (state) {
    state.selectedApp = {}
  },
  'SET_APPS' (state, apps) {
    state.apps = apps
  },
  'SET_APPS_STATISTICS' (state, statistics) {
    state.statistics = statistics
  },
  'SET_LOADING_APPS' (state, status) {
    state.loadingApps = status
  },
  'SET_LOADING_APPS_STATISTICS' (state, status) {
    state.loadingAppsStatistics = status
  },
  'SET_SELECTED_APP' (state, app) {
    state.selectedApp = app
  },
  'SET_SEARCH_PARAMS' (state, searchParams) {
    state.searchParams = searchParams
  },
  'SET_APP_CUSTOM_EXTRADATAS' (state, value) {
    state.appCustomExtradatas = value
  },
  'SET_APP_USERS_INSTAGRAM_LIKINGS' (state, instagramUsersLikings) {
    state.instagramUsersLikings = instagramUsersLikings
  },
  SET_APP_USERS_SPOTIFY_TOP_GENRES (state, top) {
    state.spotifyUsersTopGenres = top
  },
  SET_APP_USERS_SPOTIFY_TOP_ARTISTS (state, top) {
    state.spotifyUsersTopArtists = top
  },
  SET_APP_USERS_SPOTIFY_TOP_TRACKS (state, top) {
    state.spotifyUsersTopTracks = top
  },
  SET_TOOLBAR_DATE_RANGE (state, range) {
    state.toolbarDateRange = range
  },
  SET_TOOLBAR_DATE_RANGE_VISUAL (state, range) {
    state.toolbarDateRangeVisual = range
  },
  SET_TOOLBAR_DATES_RANGE (state, datesRange) {
    state.datesRange = datesRange
  },
  SET_TOOLBAR_MANUAL_CHARGE_STATUS (state, value) {
    state.isManualChargeShown = value
  },
  SET_TAGS_APP_EXTRA_DATA_CUSTOM (state, tags) {
    state.tags = tags
  },
  SET_APP_MODULES (state, modules) {
    state.appModules = modules
  }
}

const actions = {
  createApp (vuexContext, { companyUuid, nameApp, prefix, baseUrl }) {
    return new Promise((resolve, reject) => {
      appsService.createApp(vuexContext.getters.token, { companyUuid, nameApp, prefix, baseUrl })
        .then((data) => {
          vuexContext.dispatch('getApps')
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  async createCustomExtradata (vuexContext, data) {
    return appsService.createCustomExtradata(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data
    )
  },
  async deleteCustomExtradata (vuexContext, extradata) {
    return appsService.deleteCustomExtradata(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      extradata
    )
  },
  getApp (vuexContext, { companyId, appId, getStatistics }) {
    return new Promise((resolve, reject) => {
      vuexContext.commit('SET_LOADING_APPS', true)
      const company = companyId || vuexContext.getters.companyUuid
      appsService.getApp(vuexContext.getters.token, company, appId, { getStatistics })
        .then(response => {
          if (response.app) {
            vuexContext.commit('SET_SELECTED_APP', response.app)
            vuexContext.dispatch('getAppModules')
            resolve(response.app)
          } else {
            vuexContext.commit('SET_SELECTED_APP', {})
          }
          vuexContext.commit('SET_LOADING_APPS', false)
        })
    })
  },
  async getAppCustomExtradatas (vuexContext) {
    const response = await appsService.getAppCustomExtradatas(
      vuexContext.getters.token,
      vuexContext.rootState.companies.selectedCompany.id,
      vuexContext.getters.appUuid
    )

    vuexContext.commit('SET_APP_CUSTOM_EXTRADATAS', response)
    return true
  },
  getApps (vuexContext) {
    const companyId = vuexContext.rootState.companies.selectedCompany.id
    appsService.getApps(vuexContext.getters.token, companyId)
      .then(response => {
        vuexContext.commit('SET_APPS', response.apps.rows)
        if (vuexContext.state.apps.findIndex(element => vuexContext.getters.appUuid === element.UUID) === -1) vuexContext.commit('CLEAR_SELECTED_APP')

        if (Object.keys(vuexContext.state.selectedApp).length === 0 && response.apps.rows.length > 0) {
          vuexContext.commit('SET_SELECTED_APP', response.apps.rows[0])
        }
      })
      .catch(() => {
        vuexContext.commit('SET_APPS', [])
      })
  },
  async getAppModules (vuexContext) {
    const token = vuexContext.getters.token
    const companyId = vuexContext.getters.companyUuid
    const appId = vuexContext.getters.appUuid
    const response = await appsService.getAppModules(token, companyId, appId)

    vuexContext.commit('SET_APP_MODULES', response)
  },
  async getAppsStatistics (vuexContext) {
    try {
      const companyId = vuexContext.rootState.companies.selectedCompany.id
      const appId = vuexContext.state.selectedApp.UUID
      const searchParams = vuexContext.state.searchParams

      vuexContext.commit('SET_LOADING_APPS_STATISTICS', true)
      const response = await appsService.getAppsStatistics(vuexContext.getters.token, companyId, appId, searchParams)

      vuexContext.commit('SET_APPS_STATISTICS', response.statistics)
      vuexContext.commit('SET_LOADING_APPS_STATISTICS', false)
    } catch (e) {
      vuexContext.commit('SET_APPS_STATISTICS', {})
    }
  },
  getInstagramUsersLikings (vuexContext) {
    appsService.getInstagramUsersLikings(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid)
      .then(response => {
        vuexContext.commit('SET_APP_USERS_INSTAGRAM_LIKINGS', response.likings)
      })
      .catch(() => {
        vuexContext.commit('SET_APP_USERS_INSTAGRAM_LIKINGS', [])
      })
  },
  getUsersSpotifyTopGenres (vuexContext) {
    appsService.getUsersSpotifyTopGenres(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid)
      .then(response => {
        vuexContext.commit('SET_APP_USERS_SPOTIFY_TOP_GENRES', response.spotifyLikings || [])
      })
      .catch(() => {
        vuexContext.commit('SET_APP_USERS_SPOTIFY_TOP_GENRES', [])
      })
  },
  getUsersSpotifyTopArtists (vuexContext) {
    appsService.getUsersSpotifyTopArtists(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid)
      .then(response => {
        vuexContext.commit('SET_APP_USERS_SPOTIFY_TOP_ARTISTS', response.spotifyLikings || [])
      })
      .catch(() => {
        vuexContext.commit('SET_APP_USERS_SPOTIFY_TOP_ARTISTS', [])
      })
  },
  getUsersSpotifyTopTracks (vuexContext) {
    appsService.getUsersSpotifyTopTracks(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid)
      .then(response => {
        vuexContext.commit('SET_APP_USERS_SPOTIFY_TOP_TRACKS', response.spotifyLikings || [])
      })
      .catch(() => {
        vuexContext.commit('SET_APP_USERS_SPOTIFY_TOP_TRACKS', [])
      })
  },
  invite (vuexContext, users) {
    return new Promise((resolve, reject) => {
      const companyId = vuexContext.rootState.companies.selectedCompany.id
      const appId = vuexContext.state.selectedApp.UUID
      appsService.invite(vuexContext.getters.token, companyId, appId, users)
        .then(response => {
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateApp (vuexContext, { companyId, appId, data }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      appsService.updateApp(vuexContext.getters.token, company, app, data).then(() => {
        vuexContext.dispatch('getApp', { companyId: companyId, appId: appId, getStatistics: false })
        resolve(true)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async updateCustomExtradata (vuexContext, data) {
    return appsService.updateCustomExtradata(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data
    )
  },
  async getAppTagsOfCustomExtraData (vuexContext) {
    const response = await appsService.getAppTagsCustomExtradatas(
      vuexContext.getters.token,
      vuexContext.rootGetters.companyUuid,
      vuexContext.getters.appUuid
    )
    vuexContext.commit('SET_TAGS_APP_EXTRA_DATA_CUSTOM', response)
  }
}

const getters = {
  appModules (state) {
    return !state.appModules || !Array.isArray(state.appModules) ? [] : state.appModules.map(item => item.module)
  },
  appUuid (state) {
    return state.selectedApp.UUID
  },
  appPhoto (state) {
    return state.selectedApp.photo
  },
  datesRange (state) {
    return {
      fromDate: state.datesRange[0],
      toDate: state.datesRange.length > 1 ? state.datesRange[1] : state.datesRange[0]
    }
  },
  profileUi (state) {
    if (Array.isArray(state.selectedApp.extra_data)) {
      const index = state.selectedApp.extra_data.findIndex(item => {
        return item.field === 'profileUi'
      })
      if (index === -1) return {}
      return JSON.parse(state.selectedApp.extra_data[index].value)
    }
    return {}
  },
  selectedApp (state) {
    return state.selectedApp
  },
  searchParams (state) {
    return state.searchParams
  },
  sidebarModules (state) {
    return state.selectedApp && state.selectedApp.modules && Array.isArray(state.selectedApp.modules) ? state.selectedApp.modules : []
  },
  lastNDays (state) {
    if (Object.prototype.hasOwnProperty.call(state.searchParams, 'lastNDays')) {
      return state.searchParams.lastNDays
    }
    return 7
  },
  businessModule (state) {
    let businessModule = []
    const businessLabel = {
      p: i18n.t('general.businesses'),
      s: i18n.t('general.business')
    }
    if (state.appModules.length > 0) {
      businessModule = state.appModules.find(item => item.module === 'sidebar-business')
      if (businessModule) {
        // plural
        businessLabel.p = businessModule.label
        // singular
        businessLabel.s = businessModule.label
      }
    }
    return businessLabel
  },
  tenebitIntegration (state) {
    let tenebitModule
    if (state.appModules.length > 0) {
      tenebitModule = state.appModules.find(item => item.module === 'tenebit-integration')
      if (tenebitModule) {
        return tenebitModule
      }
    }
    return false
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
